/**
 * Formats a Dominican ID (cédula) string to the pattern 999-9999999-9
 * @param {string} cedula - The identification number to format
 * @returns {string} - Formatted identification or original string if invalid
 */
export const formatCedula = (cedula) => {
  if (!cedula) return '';

  // Remove any non-digit character
  const cleanedCedula = cedula.replace(/\D/g, '');

  // Check if we have exactly 11 digits
  if (cleanedCedula.length !== 11) {
    return cedula;
  }

  // Format as XXX-XXXXXXX-X
  return `${cleanedCedula.slice(0, 3)}-${cleanedCedula.slice(3, 10)}-${cleanedCedula.slice(10)}`;
};

/** '0' cédula, '1' pasaporte: el mismo enum de optionsDocumentTypes y RHFDocumentIdField. */
const TIPO_CEDULA = '0';
const TIPO_PASAPORTE = '1';

/**
 * Documento de identidad tal como debe VERSE. El dato se guarda sin separadores —los guiones son
 * presentación— así que toda vista de solo lectura tiene que pasar por aquí; pintar el valor crudo
 * es lo que hacía que la misma cédula se viera distinta en la tabla y en el formulario.
 *
 * El tipo es opcional: sin él se deduce por la forma (11 dígitos = cédula). Pasarlo evita el único
 * caso ambiguo, un pasaporte de 11 dígitos, que sin tipo saldría con guiones.
 *
 * @param {string} valor Documento en cualquier formato; se normaliza antes de formatear.
 * @param {string|number} [tipo] '0' cédula, '1' pasaporte.
 * @param {string} [vacio] Qué devolver cuando no hay documento.
 */
export const formatDocumento = (valor, tipo, vacio = '') => {
  if (!valor) return vacio;

  const texto = String(valor).trim();
  if (!texto) return vacio;

  const tipoTexto = tipo === null || tipo === undefined ? '' : String(tipo);
  if (tipoTexto === TIPO_PASAPORTE) return texto.toUpperCase();

  const digitos = texto.replace(/\D/g, '');
  if (tipoTexto === TIPO_CEDULA && digitos.length !== 11) return texto.toUpperCase();

  return formatCedula(texto);
};
